import { Link, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import PublicLayout from "@/components/PublicLayout";
import Seo from "@/components/Seo";
import { CheckCircle2 } from "lucide-react";

export default function ThankYou() {
  const [params] = useSearchParams();
  const ref = params.get("ref");
  useEffect(() => {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", "Lead");
    }
  }, []);
  return (
    <PublicLayout>
      <Seo title="Thanks — enquiry received | Site Cleanup" description="Thanks for your site clean-up quote enquiry. We'll review and be in touch." />
      <section className="py-20 md:py-32">
        <div className="rs-container max-w-2xl text-center">
          <CheckCircle2 className="mx-auto text-safety" size={64} />
          <span className="rs-eyebrow mt-6 block">Enquiry received</span>
          <h1 className="mt-3 text-4xl md:text-6xl uppercase font-display">Thanks — we've got your details.</h1>
          <p className="mt-4 text-muted-foreground">Our team will review your enquiry and photos, then match the job with a suitable local contractor where available. You'll usually hear back within 1–2 business days. A confirmation email is on its way to your inbox.</p>
          {ref && (
            <p className="mt-6 text-sm inline-block bg-white border border-border px-5 py-3" data-testid="thankyou-ref">
              Your reference: <strong className="font-mono text-safety text-base tracking-widest ml-1">{ref}</strong>
            </p>
          )}
          <div className="mt-10 flex gap-3 justify-center flex-wrap">
            <Link to="/" className="rs-btn-outline">Back to home</Link>
            <Link to="/services" className="rs-btn-primary">Browse services</Link>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
